import { useState, useCallback } from 'react';

let tabCounter = 2;

export const useTabs = () => {
  const [tabs, setTabs] = useState([{ id: 'tab-1', label: null, tooltip: null, connected: false }]);
  const [activeTabId, setActiveTabId] = useState('tab-1');

  const addTab = useCallback(() => {
    const id = `tab-${tabCounter++}`;
    setTabs((prev) => [...prev, { id, label: null, tooltip: null, connected: false }]);
    return id;
  }, []);

  const removeTab = useCallback((id) => {
    setTabs((prev) => {
      if (prev.length <= 1) return prev;
      return prev.filter((t) => t.id !== id);
    });
  }, []);

  const setTabLabel = useCallback((id, label) => {
    setTabs((prev) => prev.map((t) => (t.id === id ? { ...t, label } : t)));
  }, []);

  const setTabTooltip = useCallback((id, tooltip) => {
    setTabs((prev) => prev.map((t) => (t.id === id ? { ...t, tooltip } : t)));
  }, []);

  const setTabConnected = useCallback((id, connected) => {
    setTabs((prev) => prev.map((t) => (t.id === id ? { ...t, connected } : t)));
  }, []);

  return {
    tabs,
    activeTabId,
    setActiveTabId,
    addTab,
    removeTab,
    setTabLabel,
    setTabTooltip,
    setTabConnected,
  };
};
